import React from 'react';
import { Logo } from '~/source/ui/logo/logo';
import { Selector } from '~/source/ui/selector/selector';
import { SplashLayout } from '~/source/ui/splash-layout/splash-layout';
import type { Companies as Props } from './companies.page.types';

export const Companies: React.FC<Props> = ({ selector }) => (
  <SplashLayout>
    <div className="companies">
      <Logo elementName="h1" variant="light" />
      <Selector {...selector} />
    </div>
  </SplashLayout>
);
